<template>
  <div style="width: 100%; height: 93%">
    <el-table
      :data="tableData"
      stripe
      border
      style="width: 100%"
      class="tabWrap"
      height="100%"
      :header-cell-style="{
        'background-color': '#F7F7F7',
      }"
      :cell-style="cellStyle"
      @cell-click="cellClick"
    >
      <el-table-column
        v-for="(v, i) in tabHead"
        :key="i"
        :prop="v.prop"
        :label="v.label"
        min-width="60"
        :width="v.label == '关联设备数' || v.label == '计划周期' ? '110' : ''"
        :show-overflow-tooltip="true"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row[v.prop] && v.prop == 'handleUser'">
            <el-link
              type="primary"
              v-for="(item, index) in scope.row.handlersInfo"
              :key="item.id"
              @click="toUserPage(item)"
              >{{
                index == scope.row.handlersInfo?.length - 1
                  ? item.name
                  : `${item.name}、`
              }}</el-link
            >
          </span>
          <span v-else>{{ scope.row[v.prop] }}</span>
        </template>
      </el-table-column>
      <el-table-column label="开启状态" align="center" width="90">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.open"
            :disabled="
              !judgeAuthority(
                $route.path == '/maintainPlan'
                  ? 'houqinguanli:baoyangguanli:maintainPlan:edit'
                  : 'houqinguanli:xunjianguanli:patrolPlan:edit'
              )
            "
            @change="updateState(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="120"
        align="center"
        v-if="
          judgeAuthority(
            $route.path == '/maintainPlan'
              ? 'houqinguanli:baoyangguanli:maintainPlan:edit'
              : 'houqinguanli:xunjianguanli:patrolPlan:edit'
          )
        "
      >
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="addPlan(scope.row)"
            >编辑</el-button
          >
          <el-button type="text" size="small" @click="deleteBtn(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 保养计划-点击关联设备-显示设备保养详情 -->
    <PlanDeviceInfo v-if="deviceInfoCom" :clickItem="clickItem" />
  </div>
</template>

<script>
import { judgeAuthority } from "@/assets/js/utils";
import PlanDeviceInfo from "./PlanDeviceInfo";
import api from "@/api";
export default {
  components: {
    PlanDeviceInfo,
  },
  props: {
    tabHead: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      deviceInfoCom: false,
      clickItem: {},
    };
  },
  methods: {
    judgeAuthority,
    toUserPage(data) {
      this.$router.push({
        name: "authority",
        params: { userId: data.id },
      });
    },
    deleteBtn(row) {
      this.$confirm("是否确认？", "删除计划", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await api.patrolPlanDeletePlan({}, row.id);
          if (res && res.data.code == 200) {
            this.$message.success("删除成功");
            this.$store.commit("SET_LOADING", true);
            setTimeout(() => {
              this.$parent.getList();
            }, 1000);
          }
        })
        .catch(() => {});
    },
    async updateState(row) {
      let res = await api.patrolPlanChangeState({
        id: row.id,
        state: row.state == "ENABLE" ? "DISABLE" : "ENABLE",
      });
      if (res && res.data.code == 200) {
        this.$message.success("修改成功!");
        this.$store.commit("SET_LOADING", true);
        setTimeout(() => {
          this.$parent.getList();
        }, 1000);
      }
    },
    addPlan(row) {
      if (row.state == "ENABLE") {
        this.$message.error("该计划尚未关闭，请先关闭计划再进行修改");
        return;
      }
      let obj = Object.assign(row, {
        title: "编辑计划",
      });
      this.$emit("handleAddEdit", obj);
    },
    cellStyle(row) {
      if (
        row.column.label === "计划名称" ||
        row.column.label == "关联设备数" ||
        row.column.label === "巡检计划"
      ) {
        return "color:#28CCCB;cursor: pointer;";
      }
    },
    cellClick(row, column) {
      if (column.label == "关联设备数") {
        this.clickItem = row;
        this.deviceInfoCom = true;
      } else if (column.label == "计划名称" || column.label === "巡检计划") {
        this.$emit("sentIndexFn", { index: 2, row: row });
      }
    },
  },
  created() {},
};
</script>

<style></style>
